import React from 'react';
import { View, TouchableOpacity } from 'react-native';
import MyAppText from '../../../components/MyAppText';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props {
    label: string;
    children?: React.ReactNode;
    searchComponent?: React.ReactNode;
    isOpen: boolean;
    onToggle: () => void;
    count?: number;
}

function CollapsibleFilter({ label, children, searchComponent, isOpen, onToggle, count }: Props) {
    const { styles, theme } = useStyles(styleSheet);

    return (
        <View style={{ zIndex: isOpen ? 9999 : 1 }}>
            <TouchableOpacity style={styles.header} onPress={onToggle}>
                <View style={{ flexDirection: 'row', alignItems: 'center', gap: 12 }}>
                    <MyAppText style={styles.label}>{label}</MyAppText>
                    {count !== undefined && count > 0 && (
                        <View style={styles.badge}>
                            <MyAppText style={styles.badgeText}>{count}</MyAppText>
                        </View>
                    )}
                </View>
                <FontAwesomeIcon
                    icon={isOpen ? faChevronUp : faChevronDown}
                    fontSize={14}
                    color={theme.colors.primary['500']}
                />
            </TouchableOpacity>
            {isOpen && searchComponent && <View style={styles.searchContent}>{searchComponent}</View>}
            {isOpen && children && <View style={styles.content}>{children}</View>}
        </View>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingVertical: 16,
        paddingHorizontal: 16,
        borderRadius: 8,
        backgroundColor: theme.colors.backgrounds['BG-2']
    },
    label: {
        fontSize: 16,
        color: theme.colors.labelColor,
        fontWeight: '600'
    },
    content: {
        marginTop: 16,
        paddingLeft: 16
    },
    searchContent: {
        marginTop: 16,
    },
    badge: {
        backgroundColor: theme.colors.primary['500'],
        borderRadius: 4,
        paddingHorizontal: 6,
        paddingVertical: 2,
        minWidth: 22,
        alignItems: 'center',
    },
    badgeText: {
        color: theme.colors.white['500'],
        fontSize: 14,
        fontWeight: 'bold',
    }
}));

export default CollapsibleFilter;
